import { useContrastQuery } from '../../../../hooks/use-contrast-query'
import { Query } from '../../../../hooks/queries'
import { BaseApiResponse } from '../../../../api/shared'
import {
  deleteConfiguration,
  DeleteConfigurationArgs
} from './requests/delete-configuration'
import { HTTPError } from '../../../../api/fetch/decorate-fetch'

export interface UseDeleteConfigurationQueryProps {
  organizationUuid: string
  configurationId?: number
  isEnabled: boolean
  successCallback: () => void
}

export interface UseDeleteConfigurationQueryResponse {
  data: BaseApiResponse
  error: HTTPError | null
  isError: boolean
  isLoading: boolean
}

export type UseDeleteConfigurationQuery = (
  props: UseDeleteConfigurationQueryProps
) => UseDeleteConfigurationQueryResponse

export const useDeleteConfigurationQuery: UseDeleteConfigurationQuery = ({
  organizationUuid,
  configurationId,
  isEnabled,
  successCallback
}: UseDeleteConfigurationQueryProps) => {
  const { data, error, isError, isLoading } = useContrastQuery<
    DeleteConfigurationArgs,
    any
  >(
    [
      Query.INTEGRATIONS_DELETE_JIRA_CONFIGURATION,
      organizationUuid,
      configurationId
    ],
    deleteConfiguration,
    {
      organizationUuid,
      configurationId
    },
    {
      enabled: !!configurationId && isEnabled,
      onSuccess: successCallback
    }
  )

  return {
    data,
    error,
    isError,
    isLoading
  }
}
